
import { useAdminLeadAccounts } from "@/hooks/admin/useAdminLeadAccounts";
import { useAdminAccounts } from "@/hooks/admin/useAdminAccounts";

export const useAccountsManagement = (providerId: string | null) => {
  // Lead accounts management
  const {
    leadAccounts,
    loading: leadAccountsLoading,
    loadLeadAccounts,
    createLeadAccount,
    updateLeadAccount,
    deleteLeadAccount
  } = useAdminLeadAccounts();
  
  // Accounts management
  const {
    accounts,
    loading: accountsLoading,
    loadAccounts,
    createAccount,
    updateAccount,
    deleteAccount,
    toggleAccountActive
  } = useAdminAccounts(providerId);

  return {
    // Lead accounts related
    leadAccounts,
    leadAccountsLoading,
    loadLeadAccounts,
    createLeadAccount,
    updateLeadAccount,
    deleteLeadAccount,
    
    // Accounts related
    accounts,
    accountsLoading,
    loadAccounts,
    createAccount,
    updateAccount,
    deleteAccount,
    toggleAccountActive
  };
};
